"use client";

import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { SidebarHeader } from "@/components/scriba/Header";
import { Sidebar, SidebarCollapseProvider, SidebarDocumentList } from "../components/default/sidebar";
import { useClaimTemporaryDocuments } from "../components/scriba/document/hooks/useClaimTemporaryDocuments";

interface LayoutClientInnerProps {
  children: ReactNode;
  initialSidebarCollapsed: boolean;
  isUserAdmin: boolean;
}

export function LayoutClientInner({ children, initialSidebarCollapsed, isUserAdmin }: LayoutClientInnerProps) {
  const [isMobile, setIsMobile] = useState(false);

  // Automatically claim temporary documents when user signs in
  useClaimTemporaryDocuments();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <SidebarCollapseProvider initialCollapsed={initialSidebarCollapsed}>
      <div className="flex h-screen overflow-hidden">
        {/* Left Sidebar */}
        <Sidebar isUserAdmin={isUserAdmin} sidebarHeader={<SidebarHeader />}>
          <SidebarDocumentList isUserAdmin={isUserAdmin} />
        </Sidebar>

        {/* Main Content Area */}
        <div className={`flex-1 flex flex-col min-w-0 bg-background ${isMobile ? "relative" : ""}`}>
          <main className="flex-1 overflow-auto">{children}</main>
        </div>
      </div>
    </SidebarCollapseProvider>
  );
}
